import { Link } from 'react-router-dom';
import { Config } from '../interfaces';

interface Props {
  config: Config;
  centerId?: string;
  selectedLanguage: string;
  withDialog?: boolean;
  hideMenu: VoidFunction;
}

function NavigationLinks({ config, centerId, selectedLanguage, withDialog, hideMenu }: Props) {
  if (withDialog) {
    const productListParams = new URLSearchParams({
      center: centerId!,
      language: selectedLanguage,
      page: 'productlist',
      displayoption: 'dialog',
      closeurl: `${window.location.origin}/center/${centerId}/withdialog/product-list`,
    });

    const retailListParams = new URLSearchParams({
      center: centerId!,
      language: selectedLanguage,
      page: 'retaillist',
      displayoption: 'dialog',
      closeurl: `${window.location.origin}/center/${centerId}/withdialog/retail-list`,
    });

    return (
      <>
        <Link to={`/center/${centerId}/withdialog/film-list`} className='item' onClick={hideMenu}>
          Performance List Cinema
        </Link>
        <Link
          to={{
            pathname: `${config.apiService.webshop.endpoint}/landingpage?${productListParams.toString()}`,
          }}
          target='_top'
          className='item'
          onClick={hideMenu}
        >
          Product List
        </Link>
        <Link
          to={{
            pathname: `${config.apiService.webshop.endpoint}/landingpage?${retailListParams.toString()}`,
          }}
          target='_top'
          className='item'
          onClick={hideMenu}
        >
          Retail List
        </Link>
        <Link to={`/center/${centerId}/film-list`} className='item' onClick={hideMenu}>
          Compeso Mock
        </Link>
      </>
    );
  } else {
    const homeParams = new URLSearchParams({
      center: centerId!,
      language: selectedLanguage,
      page: 'home',
      cs: '[{"name":"marketing","consent":true},{"name":"preferences","consent":false}]',
    });

    return (
      <>
        <Link
          to={`/center/${centerId}/film-list?cs=[{"name":"marketing","consent":true},{"name":"preferences","consent":false},{"name":"localization","consent":false}]`}
          className='item'
          onClick={hideMenu}
        >
          Performance List Cinema
        </Link>
        <a href={`${config.apiService.webshop.endpoint}/landingpage?${homeParams.toString()}`} className='item'>
          Performance List [with cs param]
        </a>
        <Link to={`/center/${centerId}/performance-list`} className='item' onClick={hideMenu}>
          Performance List Iframe
        </Link>
        <Link to={`/center/${centerId}/product-list`} className='item' onClick={hideMenu}>
          Product List
        </Link>
        <Link to={`/center/${centerId}/retail-list`} className='item' onClick={hideMenu}>
          Retail List
        </Link>
        <Link to={`/center/${centerId}/withdialog/`} className='item' onClick={hideMenu}>
          Dialog Option Mock
        </Link>
      </>
    );
  }
}

export default NavigationLinks;
